import axios from '~common/assets/js/axios.js'
import utils from '~common/commonModule/magicCube/assets/js/utils'

// import xesBaseFn from '~common/assets/js/xes.base.js'
// import * as MockData from '../../MockData/mockdata.js'
// import { debug } from 'util'

const actions = {
  // 登陆信息
  LOGIN (context) {
    this.loading = this._vm.$loading({
      background: 'rgba(255, 255, 255, 0.5)',
      loadingStatus: true
    })
    axios
      .get('/user/login')
      .then(res => {
        this.loading.close()
        this.loading.loadingStatus = false
        const { realname, avatar, menu, department_id, subject_id } = res.data
        context.commit('setBaseData', {
          realname,
          avatar,
          menu,
          department_id,
          subject_id
        })
        context.dispatch('GETBASECONFIGS')
        context.dispatch('GETRESOURCELISTS')
        context.dispatch('GETCOMPONENTSLISTS')
      })
      .catch(err => {
        this.loading.close()
        this.loading.loadingStatus = false
        this._vm.$msgBox.point(err.data, 'error', () => {
          window.location.href = axios.defaults.logoutUrl
        })
      })
  },
  // 获取基础配置参数
  GETBASECONFIGS (context) {
    this.loading = this._vm.$loading({
      background: 'rgba(255, 255, 255, 0.5)',
      loadingStatus: true
    })
    axios
      .post('/app/getAllBaseConfigs')
      .then(res => {
        this.loading.close()
        this.loading.loadingStatus = false
        context.commit('SETBASECONFIGS', res.data)
      })
      .catch(err => {
        this.loading.close()
        this.loading.loadingStatus = false
      })
  },
  // 获取基础信息配置信息(基本字段配置)
  GETBASESETTINGCONFIGS (context) {
    this.loading = this._vm.$loading({
      background: 'rgba(255, 255, 255, 0.5)',
      loadingStatus: true
    })
    axios
      .post('/app/getBaseConfigForSetting')
      .then(res => {
        this.loading.close()
        this.loading.loadingStatus = false
        context.commit('SETBASESETTINGCONFIGS', res.data)
      })
      .catch(err => {
        this.loading.close()
        this.loading.loadingStatus = false
      })
  },
  // 获取用户可用app列表
  GETUSERAPPLIST (context) {
    this.loading = this._vm.$loading({
      background: 'rgba(255, 255, 255, 0.5)',
      loadingStatus: true
    })
    axios
      .post('/app/getPersonalAppItems')
      .then(res => {
        this.loading.close()
        this.loading.loadingStatus = false
        context.commit('SETUSERAPPLIST', res.data)
      })
      .catch(err => {
        this.loading.close()
        this.loading.loadingStatus = false
      })
  },
  // 获取应用内数据列表
  GETAPPLISTDATA (context, params) {
    this.loading = this._vm.$loading({
      background: 'rgba(255, 255, 255, 0.5)',
      loadingStatus: true
    })
    axios
      .post('/appdata/getAppDataItems', params)
      .then(res => {
        this.loading.close()
        this.loading.loadingStatus = false
        context.commit('SETAPPLISTDATA', res.data)
      })
      .catch(err => {
        this.loading.close()
        this.loading.loadingStatus = false
      })
  },
  // 获取app基本信息
  GETAPPBASEDATA (context, params) {
    this.loading = this._vm.$loading({
      background: 'rgba(255, 255, 255, 0.5)',
      loadingStatus: true
    })
    axios
      .post('/appdata/getAppBaseDataById', params)
      .then(res => {
        this.loading.close()
        this.loading.loadingStatus = false
        context.commit('SETAPPBASEDATA', res.data)
        let appConfigParams = {
          id: res.data.app_id
        }
        if (params.ptoken) {
          appConfigParams.ptoken = params.ptoken
          appConfigParams.ptoken_type = params.ptoken_type
        }
        context.dispatch('GETAPPCONFIG', appConfigParams)
      })
      .catch(err => {
        this.loading.close()
        this.loading.loadingStatus = false
      })
  },
  // 获取app关联目录信息
  GETAPPRELATIONCATALOGINFOS (context, params) {
    this.loading = this._vm.$loading({
      background: 'rgba(255, 255, 255, 0.5)',
      loadingStatus: true
    })
    axios
      .post('/appdata/getAppRelationCatalogById', params)
      .then(res => {
        this.loading.close()
        this.loading.loadingStatus = false
        context.commit('SET_APP_RELATION_CATALOG_INFOS', res.data)
      })
      .catch(err => {
        this.loading.close()
        this.loading.loadingStatus = false
      })
  },
  // 获取应用配置
  GETAPPCONFIG (context, params) {
    this.loading = this._vm.$loading({
      background: 'rgba(255, 255, 255, 0.5)',
      loadingStatus: true
    })
    context.state.appConfig = {}
    context.state.appEditConfigs = {}
    let tokenType = utils.getQueryByName(location.href, 'tokenType')
    tokenType && (params.ptoken_type = tokenType)

    axios
      .post('/app/getAppConfig', params)
      .then(res => {
        this.loading.close()
        this.loading.loadingStatus = false
        context.commit('SETAPPCONFIG', res.data)
      })
      .catch(err => {
        this.loading.close()
        this.loading.loadingStatus = false
      })
  },
  // 获取所有应用列表
  GETALLAPPLIST (context) {
    this.loading = this._vm.$loading({
      background: 'rgba(255, 255, 255, 0.5)',
      loadingStatus: true
    })
    axios
      .post('/app/getAllAppItems')
      .then(res => {
        this.loading.close()
        this.loading.loadingStatus = false
        context.commit('SETALLAPPLIST', res.data)
      })
      .catch(err => {
        this.loading.close()
        this.loading.loadingStatus = false
      })
  },
  // 获取资源库列表
  GETRESOURCELISTS (context) {
    this.loading = this._vm.$loading({
      background: 'rgba(255, 255, 255, 0.5)',
      loadingStatus: true
    })
    axios
      .post('/app/getResourceLibs')
      .then(res => {
        this.loading.close()
        this.loading.loadingStatus = false
        context.commit('SETRESOURCELISTS', res.data)
      })
      .catch(err => {
        this.loading.close()
        this.loading.loadingStatus = false
      })
  },
  // 获取前端组件
  GETCOMPONENTSLISTS (context) {
    this.loading = this._vm.$loading({
      background: 'rgba(255, 255, 255, 0.5)',
      loadingStatus: true
    })
    axios
      .post('/app/getFeComponents')
      .then(res => {
        this.loading.close()
        this.loading.loadingStatus = false
        context.commit('SETCOMPONENTSLISTS', res.data)
      })
      .catch(err => {
        this.loading.close()
        this.loading.loadingStatus = false
      })
  },
  // 获取一起读书&一起阅读预览数据
  async GETREADARTICLEPREVIEWDATA (context, params) {
    const res = await axios.post('/appdata/getAggReleasePrepare', params)
    // mock
    // const res = await axios.post('http://xyyapi.100tal.com/mock/267/appdata/getAggReleasePrepare', params)
    if (res.status !== 100) {
      return
    }
    const resData = res.data
    let materialInfoList = []
    if (resData.readingOneTimeReply && resData.readingOneTimeReply.materialInfoList) {
      materialInfoList = resData.readingOneTimeReply.materialInfoList || []
    } else if (resData.readingReply) {
      materialInfoList = resData.readingReply || []
    }

    console.log('materialInfoList', materialInfoList)
    context.commit('SETREADARTICLEPREVIEWDATA', materialInfoList)
  }
}
export default actions



// WEBPACK FOOTER //
// ./common/commonModule/magicCube/vuex/magicCube/actions.js